import { Add, Search, Tune } from "@mui/icons-material";
import {
  Autocomplete,
  FormControl,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  OutlinedInput,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DatePickerDMY from "../DatePickerDMY";
import noData from "../../assets/svg/Emptyfile1.svg";
import { DataGrid } from "@mui/x-data-grid";
import { newHost } from "../../pages/Categories/CategoryProfile";
import axios from "axios";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";
import defaultImg from "../../assets/svg/defultImage.svg";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import DeleteModal from "../Modals/DeleteModal";
import { useNavigate } from "react-router";
import { database } from "../../firebase";
import {
  ref,
  query,
  limitToLast,
  onChildAdded,
  onChildChanged,
} from "firebase/database";
import MarkAllAsRead from "../SharedModule/MarkAllAsRead";

const HelpRequests = () => {
  const { user } = useSelector((state) => state.auth);
  const token = user?.token;
  // Header
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  //requests
  const [helpRequests, setHelpRequests] = useState([]);
  const [requestStatuses, setRequestStatuses] = useState([]);
  // paginations functions
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  // table
  const [menuState, setMenuState] = useState({
    anchorEl: null,
    row: null,
  });
  const handleClick = (event, row) => {
    setMenuState({
      anchorEl: event.currentTarget,
      row: row,
    });
    setRequestId(row.id);
  };
  const handleClose = () => {
    setMenuState({
      anchorEl: null,
      row: null,
    });
  };
  const navigate = useNavigate();
  // table columns
  const columns = [
    {
      field: "id",
      headerName: "Reference",
      flex: 1.2,
      minWidth: 220,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            gap: "4px",
          }}
        >
          <Tooltip
            title={`Request ID: #${params.row.id}`}
            placement="top"
            arrow
          >
            <span
              style={{
                fontSize: "12px",
                fontWeight: 600,
                color: "#444",
                backgroundColor: "#f0f0f0",
                border: "1px solid #e0e0e0",
                borderRadius: "6px",
                padding: "2px 6px",
                // letterSpacing: "0.3px",
                cursor: "default",
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                // whiteSpace: "nowrap",
                display: "block",
              }}
            >
              {params.row.reference || `#${params.row.id}`}
            </span>
          </Tooltip>
          {(params.row.is_read == "0" || newRequestIds.has(params.row.id)) &&
            !updatedStatusIds.has(params.row.id) && (
              <span className="new-badge">NEW</span>
            )}
        </div>
      ),
    },
    {
      field: "user",
      headerName: "Client Name",
      flex: 1,
      minWidth: 120,
      renderCell: (params) =>
        params.row?.user ? (
          <div
            className=" d-flex justify-content-start align-items-center gap-1"
            style={{ width: "95%" }}
          >
            <img
              src={
                params.row?.user?.profile_photo_path
                  ? `${newImageUrl}${params.row?.user?.profile_photo_path}`
                  : defaultImg
              }
              width={30}
              height={30}
              style={{ borderRadius: "50%" }}
              alt=""
            />
            <span>{params.row?.user?.name}</span>
          </div>
        ) : (
          <span>-</span>
        ),
    },
    {
      field: "user_vehicle",
      headerName: "Car Model",
      flex: 1,
      minWidth: 120,
      renderCell: (params) =>
        params.row?.user_vehicle ? params.row?.user_vehicle : "-",
    },
    {
      field: "phone",
      headerName: "Mobile Number",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        params.row?.user ? params.row?.user?.phone_number : "-",
    },
    {
      field: "type",
      headerName: "Request Type",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        params.row?.sub_type ? "Product Request" : "Support Request",
    },
    {
      field: "category",
      headerName: "Category",
      flex: 0.7,
      minWidth: 80,
      renderCell: (params) =>
        params.row?.category.parent ? (
          <div className="">
            <img
              src={
                params.row?.category?.parent?.icon_url
                  ? `${newImageUrl}${params.row?.category?.parent?.icon_url}`
                  : defaultImg
              }
              style={{ width: "30px", height: "30px" }}
              alt=""
            />
          </div>
        ) : (
          <span>-</span>
        ),
    },
    {
      field: "created_at",
      headerName: "Time",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        `${new Date(params.row?.created_at).toLocaleDateString()} ${new Date(params.row?.created_at).toLocaleTimeString()}`,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.9,
      minWidth: 140,
      renderCell: (params) => {
        const isUpdated = updatedStatusIds.has(params.row.id);
        const transition = statusTransitions[params.row.id];

        return (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "4px 8px",
              borderRadius: "10px",
              backgroundColor: isUpdated
                ? "rgba(62,173,163,0.07)"
                : "transparent",
              animation: isUpdated ? "statusCellPulse 0.8s ease both" : "none",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "5px",
                width: "100%",
              }}
            >
              {isUpdated && transition && (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <span
                    style={{
                      fontSize: "9px",
                      color: "#bbb",
                      fontWeight: 600,
                      letterSpacing: "0.5px",
                      textTransform: "uppercase",
                    }}
                  >
                    was
                  </span>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px",
                      backgroundColor: "#f5f5f5",
                      border: "1px solid #e0e0e0",
                      borderRadius: "20px",
                      padding: "2px 8px",
                    }}
                  >
                    {transition.oldIcon && (
                      <img
                        src={transition.oldIcon}
                        alt=""
                        style={{
                          width: "11px",
                          height: "11px",
                          objectFit: "contain",
                          filter: "grayscale(1)",
                          opacity: 0.45,
                        }}
                      />
                    )}
                    <span
                      style={{
                        fontSize: "10px",
                        fontWeight: 600,
                        color: "#bbb",
                        whiteSpace: "nowrap",
                        textDecoration: "line-through",
                      }}
                    >
                      {transition.oldName}
                    </span>
                  </div>
                </div>
              )}
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  backgroundColor: isUpdated
                    ? "rgba(62,173,163,0.13)"
                    : "#f5f5f5",
                  border: `1.5px solid ${isUpdated ? "#3EADA3" : "#e0e0e0"}`,
                  borderRadius: "20px",
                  padding: "4px 10px",
                  transition:
                    "background-color 0.4s ease, border-color 0.4s ease",
                  animation: isUpdated
                    ? "statusNewPop 0.5s ease both, statusGlowPulse 0.8s ease 0.3s both"
                    : "none",
                }}
              >
                <img
                  src={params.row?.status_icon || defaultImg}
                  alt=""
                  style={{
                    width: "14px",
                    height: "14px",
                    objectFit: "contain",
                    animation: isUpdated
                      ? "statusIconBounce 0.5s ease 0.15s both"
                      : "none",
                  }}
                />
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "11px",
                    color: isUpdated ? "#3EADA3" : "#444",
                    whiteSpace: "nowrap",
                    transition: "color 0.3s ease",
                  }}
                >
                  {params.row?.status || "-"}
                </span>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "agentable",
      headerName: "Agent Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        params.row?.agentable ? params.row?.agentable?.name : "User",
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.9,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton
            disableRipple
            size="small"
            onClick={async () => {
              if (params.row.is_read == "0") {
                await toggleReadStatus(params.row);
              }
              setUpdatedStatusIds((prev) => {
                const next = new Set(prev);
                next.delete(params.row.id);
                sessionStorage.setItem(
                  "help_updatedStatusIds",
                  JSON.stringify([...next]),
                );
                return next;
              });
              setStatusTransitions((prev) => {
                const next = { ...prev };
                delete next[params.row.id];
                sessionStorage.setItem(
                  "help_statusTransitions",
                  JSON.stringify(next),
                );
                return next;
              });
              navigate(`/helpRequests/${params.row.id}`);
            }}
          >
            <RemoveRedEyeOutlinedIcon fontSize="small" />
          </IconButton>
          <IconButton
            disableRipple
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleClick(e, params.row);
            }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <Menu
            anchorEl={menuState.anchorEl}
            open={Boolean(menuState.anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            slotProps={{
              paper: {
                sx: {
                  borderRadius: 2,
                  p: 2,
                  backgroundColor: "#F9F9F9",
                },
              },
            }}
          >
            <MenuItem
              onClick={async () => {
                if (menuState.row?.is_read == "0") {
                  await toggleReadStatus(menuState.row);
                }
                handleActivityShow();
              }}
              className="p-1"
              sx={{ display: "flex", gap: 1, borderRadius: 1 }}
            >
              <Add fontSize="medium" />
              Add Activity
            </MenuItem>
            <MenuItem
              onClick={handleDeleteShow}
              className="p-1"
              sx={{
                display: "flex",
                gap: 1,
                borderRadius: 1,
                color: "#A80101",
              }}
            >
              <DeleteOutlinedIcon />
              Delete
            </MenuItem>
            <MenuItem
              onClick={async () => {
                handleClose();
                await toggleReadStatus(menuState.row);
              }}
              className="p-1"
              sx={{ display: "flex", gap: 1, borderRadius: 1 }}
            >
              <RemoveRedEyeOutlinedIcon fontSize="medium" />
              {menuState.row?.is_read == "1"
                ? "Mark as Unread"
                : "Mark as Read"}
            </MenuItem>
          </Menu>
        </>
      ),
    },
  ];
  // get requests
  const getHelpRequests = async () => {
    try {
      const response = await axios.get(`${newHost}portal/estbn_helps`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

        params: {
          page: paginationModel.page + 1,
          per_page: paginationModel.pageSize,

          ...(searchQuery &&
            (!isNaN(searchQuery)
              ? { id: searchQuery }
              : { user_name: searchQuery })),
          ...(submitChangeStatus && {
            status: submitChangeStatus,
          }),

          ...(filterDate && {
            date: filterDate,
          }),
        },
      });

      const resData = response.data.data.estbn_helps;

      setHelpRequests(resData.data);
      setRowCount(resData.total);
    } catch (error) {
      console.log(error);
    }
  };
  // Statuses
  const [submitChangeStatus, setSubmitChangeStatus] = useState("");
  const getRequestStatuses = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/estbn_helps/statuses/get`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      console.log(response.data.data.statuses);
      setRequestStatuses(response.data.data.statuses);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getRequestStatuses();
  }, []);

  useEffect(() => {
    getHelpRequests();
  }, [searchQuery, filterDate, paginationModel, submitChangeStatus]);
  // activity logs
  const { register, handleSubmit, control, reset } = useForm({
    defaultValues: {
      activity_type_id: null,
      call_type_id: null,
      call_status_id: null,
      description: null,
      comment: null,
    },
  });
  const [activityShow, setActivityShow] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const handleActivityShow = () => {
    handleClose();
    setActivityShow(true);
  };
  const handleActivityClose = () => {
    setActivityShow(false);
    reset({
      activity_type_id: null,
      call_type_id: null,
      call_status_id: null,
      description: null,
      comment: null,
    });
  };
  const [callTypes, setCallTypes] = useState([]);
  const [callStatuses, setCallStatues] = useState([]);
  const [activityTypes, setActivityTypes] = useState([]);
  const getCallTypes = async () => {
    try {
      const response = await axios.get(`${newHost}portal/call_types`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setCallTypes(response.data.data.call_types);
    } catch (error) {
      console.log(error);
    }
  };
  const getCallStatues = async () => {
    try {
      const response = await axios.get(`${newHost}portal/call_statuses`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setCallStatues(response.data.data.call_statuses);
    } catch (error) {
      console.log(error);
    }
  };
  const getActivityTypes = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/estbn_helps/activity_types/get`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setActivityTypes(response.data.data.types);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCallTypes();
    getCallStatues();
    getActivityTypes();
  }, []);
  const submitActivity = async (data) => {
    try {
      const response = await axios.post(
        `${newHost}portal/estbn_helps/${requestId}`,
        {
          ...data,
          _method: "PUT",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      toast.success(response.data.message);
      handleActivityClose();
      getHelpRequests();
    } catch (error) {
      const validationErrors = error.response?.data.errors?.validation;

      Object.entries(validationErrors).forEach(([field, messages]) => {
        messages.forEach((msg) => {
          toast.error(msg);
        });
      });
    }
  };
  // delete request
  const [showDelete, setShowDelete] = useState(false);
  const handleDeleteShow = () => {
    handleClose();
    setShowDelete(true);
  };
  const handleDeleteClose = () => {
    setShowDelete(false);
  };
  const deleteRequest = async () => {
    try {
      const response = await axios.delete(
        `${newHost}portal/estbn_helps/${requestId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      toast.success(response.data.message);
      handleDeleteClose();
      getHelpRequests();
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  // ****************** firbase ************************

  const [newRequestIds, setNewRequestIds] = useState(new Set());

  const [updatedStatusIds, setUpdatedStatusIds] = useState(() => {
    const stored = sessionStorage.getItem("help_updatedStatusIds");
    return stored ? new Set(JSON.parse(stored)) : new Set();
  });

  const [statusTransitions, setStatusTransitions] = useState(() => {
    const stored = sessionStorage.getItem("help_statusTransitions");
    return stored ? JSON.parse(stored) : {};
  });
  const pageOpenTime = useRef(Date.now());

  const clearNewRequest = (id) => {
    setNewRequestIds((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  };

  const toggleReadStatus = async (row) => {
    try {
      const response = await axios.post(
        `${newHost}portal/estbn_helps/${row.id}/toggle-read`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setHelpRequests((prev) =>
        prev.map((r) =>
          r.id === row.id
            ? { ...r, is_read: r.is_read == "1" ? "0" : "1" }
            : r,
        ),
      );
      setUpdatedStatusIds((prev) => {
        const next = new Set(prev);
        next.delete(row.id);
        sessionStorage.setItem(
          "help_updatedStatusIds",
          JSON.stringify([...next]),
        );
        return next;
      });
      setStatusTransitions((prev) => {
        const next = { ...prev };
        delete next[row.id];
        sessionStorage.setItem("help_statusTransitions", JSON.stringify(next));
        return next;
      });
      if (row.is_read == "0") {
        clearNewRequest(row.id);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    if (!token) return;
    const pageOpenTime = Date.now();
    const liveRef = query(ref(database, "help_requests"), limitToLast(5));
    const unsubscribe = onChildAdded(liveRef, (snapshot) => {
      const data = snapshot.val();
      const recordTime = new Date(data.created_at).getTime();
      if (recordTime < pageOpenTime) return;
      setTimeout(() => {
        axios
          .get(`${newHost}portal/estbn_helps`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { id: data.id },
          })
          .then((res) => {
            const newRequest = res.data.data.estbn_helps?.data?.[0];
            if (!newRequest) return;
            setHelpRequests((prev) => {
              if (prev.find((r) => r.id === newRequest.id)) return prev;
              return [{ ...newRequest, is_read: "0" }, ...prev];
            });
            setRowCount((prev) => prev + 1);
            setNewRequestIds((prev) => new Set([...prev, newRequest.id]));
          })
          .catch(console.error);
      }, 8000);
    });
    return () => unsubscribe();
  }, [token]);

  useEffect(() => {
    if (!token || !requestStatuses.length) return;

    const statusRef = ref(database, "status_updated/help_requests");

    const handleStatusUpdate = (snapshot) => {
      const requestId = Number(snapshot.key);
      const data = snapshot.val();
      if (!data?.updated_at) return;
      const recordTime = new Date(data.updated_at).getTime();
      if (recordTime < pageOpenTime.current) return;
      const newStatus = requestStatuses.find((s) => s.value === data.status);
      if (!newStatus) return;
      setHelpRequests((prev) => {
        const current = prev.find((r) => r.id === requestId);
        if (current) {
          setStatusTransitions((t) => {
            const next = {
              ...t,
              [requestId]: {
                oldName: current.status || "-",
                oldIcon: current.status_icon,
              },
            };
            sessionStorage.setItem(
              "help_statusTransitions",
              JSON.stringify(next),
            );
            return next;
          });
        }
        return prev.map((request) =>
          request.id === requestId
            ? {
                ...request,
                status: newStatus.value,
                status_icon: newStatus.icon,
              }
            : request,
        );
      });

      setUpdatedStatusIds((prev) => {
        const next = new Set([...prev, requestId]);
        sessionStorage.setItem(
          "help_updatedStatusIds",
          JSON.stringify([...next]),
        );
        return next;
      });
    };

    const unsub1 = onChildAdded(
      query(statusRef, limitToLast(1)),
      handleStatusUpdate,
    );
    const unsub2 = onChildChanged(statusRef, handleStatusUpdate);

    return () => {
      unsub1();
      unsub2();
    };
  }, [token, requestStatuses]);

  // ****************** firbase ************************

  return (
    <>
      {/* Delete Request */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={`Are you sure you want to delete this request? Confirm to proceed or cancel to keep it.`}
        deleteFunction={deleteRequest}
      />
      {/* Add  Activity Log */}
      <Modal
        show={activityShow}
        onHide={handleActivityClose}
        dialogClassName="custom-modal-size"
      >
        <Modal.Header style={{ backgroundColor: "#F8F8F8" }}>
          <Modal.Title className="text-black">Add activity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-2">
            <form onSubmit={handleSubmit(submitActivity)}>
              <div className="mt-2 mb-3 row">
                <div className="col-md-4 col-12">
                  <label htmlFor="call_type_id">Call Type</label>
                  <Controller
                    name="call_type_id"
                    control={control}
                    render={({ field }) => {
                      const options = callTypes.map((option) => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <Autocomplete
                          className="w-100"
                          size="small"
                          options={options}
                          value={
                            options.find((opt) => opt.id == field.value) || null
                          }
                          id="call_type_id"
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}
                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="m-0"
                              placeholder="Select Title"
                            />
                          )}
                        />
                      );
                    }}
                  />
                </div>
                <div className="col-md-4 col-12">
                  <label htmlFor="call_status_id">Call Status</label>
                  <Controller
                    name="call_status_id"
                    control={control}
                    render={({ field }) => {
                      const options = callStatuses.map((option) => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <Autocomplete
                          className="w-100"
                          size="small"
                          options={options}
                          value={
                            options.find((opt) => opt.id == field.value) || null
                          }
                          id="call_status_id"
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}
                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="m-0"
                              placeholder="Select Title"
                            />
                          )}
                        />
                      );
                    }}
                  />
                </div>
                <div className="col-md-4 col-12">
                  <label htmlFor="activity_type_id">Activity Type</label>
                  <Controller
                    name="activity_type_id"
                    control={control}
                    render={({ field }) => {
                      const options = activityTypes.map((option) => ({
                        label: option.effect_value,
                        id: option.id,
                        icon_url: option.icon_url,
                      }));

                      return (
                        <Autocomplete
                          className="w-100"
                          size="small"
                          options={options}
                          value={
                            options.find((opt) => opt.id == field.value) || null
                          }
                          id="activity_type_id"
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}
                          renderOption={(props, option) => (
                            <div
                              {...props}
                              className="p-2 d-flex align-items-center gap-2"
                            >
                              <div
                                style={{ width: "20px", height: "20px" }}
                                className=""
                              >
                                <img
                                  style={{ width: "100%", objectFit: "fill" }}
                                  className=""
                                  src={
                                    option.icon_url
                                      ? option.icon_url
                                      : defaultImg
                                  }
                                  alt=""
                                />
                              </div>

                              <div className="m-0">{option.label}</div>
                            </div>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="m-0"
                              placeholder="Select Title"
                            />
                          )}
                        />
                      );
                    }}
                  />
                </div>
              </div>
              <div className="my-3">
                <label htmlFor="comment">Client Comments</label>
                <textarea
                  {...register("comment")}
                  id="comment"
                  style={{
                    padding: 10,
                    borderRadius: 5,
                    border: "solid 2px #D8D8D8",
                  }}
                  rows={3}
                  className="w-100 my-1"
                  type="text"
                  placeholder="Add Comments"
                />
              </div>
              <div className="my-2">
                <label htmlFor="description">Agent Notes</label>
                <textarea
                  {...register("description")}
                  id="description"
                  style={{
                    padding: 10,
                    borderRadius: 5,
                    border: "solid 2px #D8D8D8",
                  }}
                  rows={3}
                  className="w-100 my-1"
                  type="text"
                  placeholder="Add notes"
                />
              </div>

              <div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive">
                <button
                  type="reset"
                  onClick={handleActivityClose}
                  className="btn btn-light px-5"
                >
                  Cancel
                </button>
                <button className="btn btn-dark px-5">Save</button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      <div className="m-4">
        {/* Header section */}
        <div className="">
          <h5 className="fw-semibold">User Requests - Help Requests</h5>
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-2 w-75">
            <div className="w-50 mt-1">
              <FormControl fullWidth variant="outlined" size="small">
                <OutlinedInput
                  id="search-orders"
                  placeholder="Search for Request ID, customer name, or date ..."
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  endAdornment={
                    <InputAdornment position="start">
                      <IconButton>
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <div className=" mb-2 mx-2">
              <DatePickerDMY
                value={filterDate}
                onChange={(iso) => {
                  setFilterDate(iso);
                }}
              />
            </div>
          </div>
          <div className=" d-flex align-items-center mb-2">
            <div className='me-2'>
              <MarkAllAsRead
                page="helpRequests"
                onSuccess={() => getHelpRequests()}
              />
            </div>
            <div
              onClick={(e) => setAnchorEl(e.currentTarget)}
              className="btn btn-light"
            >
              <Tune style={{ cursor: "pointer" }} />
            </div>
            <Menu
              className="my-1"
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              PaperProps={{
                sx: {
                  p: 1,
                  minWidth: 150,
                  backgroundColor: "#F9F9F9",
                  borderRadius: "10px",
                },
              }}
            >
              {requestStatuses.map((item) => (
                <div className="">
                  <MenuItem
                    key={item.value}
                    onClick={() => {
                      setSubmitChangeStatus(item.value);
                    }}
                  >
                    <div className="p-2 d-flex gap-3 align-items-center">
                      <img src={item.icon} alt="" />
                      <div className="label-size m-0">{item.value}</div>
                    </div>
                  </MenuItem>
                </div>
              ))}
            </Menu>
          </div>
        </div>
        <div className="my-3">
          {helpRequests.length > 0 ? (
            <div className="data-grid-small">
              <Paper sx={{ height: "auto", width: "100%" }}>
                <DataGrid
                  rows={helpRequests}
                  columns={columns}
                  paginationMode="server"
                  rowCount={rowCount}
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={[5, 10, 20, 50]}
                  checkboxSelection
                  disableRowSelectionOnClick
                  getRowClassName={(params) => {
                    const isUnread =
                      params.row.is_read == "0" ||
                      newRequestIds.has(params.row.id);
                    if (updatedStatusIds.has(params.row.id)) return "";
                    if (isUnread) return "new-sos-row";
                    return "";
                  }}
                  getRowHeight={() => "auto"}
                  sx={{
                    border: 0,
                    overflow: "hidden",
                    "& .MuiDataGrid-cell": {
                      py: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    },
                    // ===== Checkbox Style =====
                    "& .MuiCheckbox-root": {
                      color: "rgba(0,0,0,0.3)",
                    },
                    "& .MuiCheckbox-root.Mui-checked, & .MuiCheckbox-root.MuiCheckbox-indeterminate":
                      {
                        color: "#3EADA3",
                      },
                    "& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root": {
                      backgroundColor: "#3EADA3",
                      borderRadius: "4px",
                    },
                    "& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root path": {
                      color: "#fff",
                    },
                  }}
                  slotProps={{
                    pagination: {
                      sx: {
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                      },
                    },
                  }}
                />
              </Paper>
            </div>
          ) : (
            <div className="flex flex-column text-center">
              <img src={noData} alt="no-data" />
              <p style={{ color: "#535353" }} className="">
                No available help requests
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default HelpRequests;
